module.exports = __webpack_public_path__ + "img/首页.496e66e0.png";